import Raven from 'raven-js';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo, useCallback } from 'react';
// @ts-expect-error need definitions
import UIIFrame from 'ui-addon-iframeable/host/UIIFrame';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error need definitions
import RecaptchaField from 'MeetingsLib/components/input/RecaptchaField';
import emptyFunction from 'react-utils/emptyFunction';

// @ts-expect-error need definitions
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import { getOffline as getOfflineSelector
// @ts-expect-error need definitions
} from 'MeetingsLib/selectors/BookInfoSelectors';
import { bookPaidMeeting, trackPaidMeetingPaymentProcessing, trackPaidMeetingPaymentFailed } from 'MeetingsLib/redux/actions/FormActions';
import { getPaymentLinkInfo, getEvent as getEventSelector
// @ts-expect-error need definitions
} from 'MeetingsLib/selectors/BookInfoSelectors';
import { getPaymentSessionId, getPaymentStatusSelector, getPaymentSuccessfulSelector, getPaymentProcessingSelector } from 'MeetingsLib/selectors/PaymentStatusSelectors';
import { setPaymentStatus, setPaymentSessionId, setPaymentFinalPrice } from 'MeetingsLib/redux/actions/PaymentStatusActions';
import { buildEmbeddedCheckoutUrl, buildEmbeddedPaymentSessionUrl, unexpectedMessageHandler } from '../../utils/paymentUtils';
import { useBeforeUnload } from '../../hooks/paymentHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TOOLTIP_MESSAGES = {
  PAYMENT_UNITIALIZED: 'buttons.tooltip.paymentUnitialized',
  PAYMENT_PENDING: 'buttons.tooltip.paymentPending',
  PAYMENT_FAILED: 'buttons.tooltip.paymentFailed'
};
const ALLOW_PAYMENT = 'payment *';
const buildDisabledToolTipReason = paymentStatus => {
  switch (paymentStatus) {
    case 'SUCCESS':
      return null;
    case 'UNINITIALIZED':
      return TOOLTIP_MESSAGES.PAYMENT_UNITIALIZED;
    case 'PROCESSING':
      return TOOLTIP_MESSAGES.PAYMENT_PENDING;
    case 'FAILED':
      return TOOLTIP_MESSAGES.PAYMENT_FAILED;
    default:
      return null;
  }
};
const renderRecaptcha = (compact, recaptchaEnabled) => {
  if (recaptchaEnabled) {
    const className = compact ? 'm-x-auto' : 'p-x-8';
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: /*#__PURE__*/_jsx(RecaptchaField, {})
    });
  }
  return null;
};
const PaymentFormIframe = props => {
  const {
    branding,
    compact,
    submittingMeeting,
    goToPreviousStep,
    recaptchaEnabled
  } = props;
  const dispatch = useDispatch();
  const offline = useSelector(getOfflineSelector);
  const paymentLinkInfo = useSelector(getPaymentLinkInfo);
  const checkoutUrl = paymentLinkInfo.checkoutUrl;
  const paymentSessionId = useSelector(getPaymentSessionId);
  const event = useSelector(getEventSelector);
  const paymentStatus = useSelector(getPaymentStatusSelector);
  const isPaid = useSelector(getPaymentSuccessfulSelector);
  const isProcessingPayment = useSelector(getPaymentProcessingSelector);
  const formState = useSelector(state => state.formState);
  const formFieldsPojo = formState && formState.toJS();
  const disabledToolTipReason = useMemo(() => {
    return buildDisabledToolTipReason(paymentStatus);
  }, [paymentStatus]);
  const renderedRecaptcha = useMemo(() => {
    return renderRecaptcha(compact, recaptchaEnabled);
  }, [compact, recaptchaEnabled]);
  useBeforeUnload(isProcessingPayment || submittingMeeting);
  const handleError = errorMessage => {
    Raven.captureMessage('Error in Payment Iframe', {
      extra: {
        paymentStatus,
        paymentSessionId,
        checkoutUrl,
        message: JSON.stringify(errorMessage)
      },
      fingerprint: ['PaymentIframe']
    });
  };
  const paymentStatusHandler = useCallback(status => {
    dispatch(setPaymentStatus(status));
    if (status === 'PROCESSING') {
      dispatch(trackPaidMeetingPaymentProcessing());
    }
    if (status === 'FAILED') {
      dispatch(trackPaidMeetingPaymentFailed());
    }
  }, [dispatch]);
  const paymentSessionUrlHandler = sessionId => {
    dispatch(setPaymentSessionId(sessionId));
  };
  const handlePaymentSuccess = useCallback(message => {
    const finalPrice = message.payload && message.payload.data;
    if (finalPrice) {
      dispatch(setPaymentFinalPrice(finalPrice));
    }
    paymentStatusHandler('SUCCESS');
    void dispatch(bookPaidMeeting());
  }, [dispatch, paymentStatusHandler]);
  const handlePrepaidConfirmation = useCallback(() => {
    void dispatch(bookPaidMeeting());
  }, [dispatch]);
  const handleOnMessage = message => {
    const type = message.payload.type;
    switch (type) {
      case 'SESSION_ID':
        return paymentSessionUrlHandler(message.payload.data);
      case 'SUCCESS':
        return handlePaymentSuccess(message);
      case 'PROCESSING':
        return paymentStatusHandler('PROCESSING');
      case 'FAILED':
        return paymentStatusHandler('FAILED');
      default:
        return unexpectedMessageHandler(message);
    }
  };
  const getConnectUrl = () => {
    const email = formFieldsPojo && formFieldsPojo.email;
    const url = buildEmbeddedCheckoutUrl(checkoutUrl, email);
    const paymentSessionUrl = buildEmbeddedPaymentSessionUrl(paymentSessionId, email);
    // use regenerated session to prevent re-use of previous email by payment BE
    if (!isPaid) return url;
    return paymentSessionUrl || url;
  };
  const renderedFormButtons = useMemo(() => {
    return /*#__PURE__*/_jsx(StepButtonsFooter, {
      branding: branding,
      compact: compact,
      submittingMeeting: submittingMeeting,
      canProceed: isPaid,
      disableBackButton: isProcessingPayment,
      backButtonTooltipTitle: disabledToolTipReason ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: disabledToolTipReason
      }) : null,
      tooltipTitle: disabledToolTipReason,
      goToPreviousStep: goToPreviousStep,
      goToNextStep: isPaid ? handlePrepaidConfirmation : null,
      isLastStep: true,
      offline: offline
    }, "buttons");
  }, [isPaid, handlePrepaidConfirmation, branding, compact, submittingMeeting, goToPreviousStep, offline, disabledToolTipReason, isProcessingPayment]);
  return /*#__PURE__*/_jsx("div", {
    className: "flex-column min-height-3",
    style: {
      transform: 'scale(0.9)'
    },
    children: /*#__PURE__*/_jsxs(UICardWrapper, {
      className: "flex-column min-height-0",
      children: [/*#__PURE__*/_jsxs(UICardSection, {
        className: "flex-column min-height-0 p-all-0",
        scrollable: true,
        children: [/*#__PURE__*/_jsx(UIIFrame, {
          "data-selenium-test": "paid-meetings-embed",
          allow: ALLOW_PAYMENT,
          onInitError: handleError,
          onMessage: handleOnMessage,
          onReady: emptyFunction,
          onReadyError: handleError,
          height: 710,
          width: '100%',
          scrolling: true,
          embeddedPassthruProps: {
            formFields: formFieldsPojo,
            eventDate: event && event.dateTime
          },
          src: getConnectUrl(),
          iframePassthruProps: {
            'data-test-id': 'payment-iframe'
          }
        }), renderedRecaptcha]
      }), renderedFormButtons]
    })
  });
};
export default PaymentFormIframe;